(function () {
    var federatedLogin = {
        accessOptions: document.querySelector('.access-options'),
        purchaseBlock: document.querySelector('.block'),
        federations: document.querySelector('.federations'),
        isTablet: window.matchMedia(`(max-width: ${UX.grid.screenSm - 1}px)`).matches,
        noMatchFoundMessage: 'No matches found.',
        isDenialsRedirect: false,
        seamlessAccessParams: {},
        areOtherOptionsShown: false,
        useTabKey: false,
        classes: [],
        currentNoResultsState: '',
        institutionWrapperMargin: 45,

        init: function () {
            var ms;
            var $instSaveChoiceInput = $('.preference-institution-input');
            var $mobileBackContainer = $('.mobile-back-container');
            var $backContainer = $('.back-container');

            federatedLogin.seamlessAccessParams = federatedLogin.constructSeamlessAccessParams();

            if (federatedLogin.accessOptions && federatedLogin.isDenialsRedirect) {
                federatedLogin.updateMaggicSuggestProperties();
                federatedLogin.constructSeamlessAccessLabels();
            }

            if (typeof jQuery.ui === 'undefined' || $('.sso-start-widget').length === 0) {
                // If jQuery UI library is not used.
                return;
            }

            ms = $('.inst-search-auto-complete').magicSuggest({
                allowFreeEntries: false,
                data: '/pb/widgets/shibbolethLogin/institutions',
                dataUrlParams: {redirectUri: new URL(window.location.href).searchParams.get('redirectUri')},
                hideTrigger: true,
                maxSelection: 1,
                useTabKey: `${federatedLogin.useTabKey}`,
                method: 'get',
                minChars: 1,
                mode: 'remote',
                resultsField: 'name',
                placeholder: 'Search By University or Organization',
                noSuggestionText: `<div class="no-results" style="display: block;"><span>${federatedLogin.noMatchFoundMessage}</span></div>`,
                renderer: function (data) {
                    if (data) {
                        if ($('.ms-res-ctn.dropdown-menu').length > 0) {
                            federatedLogin.showEnterToSelectLabel();
                        }
                        return (
                            '<span data-entityid="' +
                            data.entityId +
                            '" data-name="' +
                            data.federationName +
                            '" ' +
                            'class="sso-institution" href="' +
                            data.institutionUrl +
                            '">' +
                            data.name +
                            '</span>'
                        );
                    }
                },
            });

            if (federatedLogin.accessOptions && federatedLogin.isDenialsRedirect) {
                federatedLogin.setObserver();
                federatedLogin.setFederationWrapperMargin();
                federatedLogin.setFederationWrapperListener();
            }

            $(ms).on('blur', function (e) {
                $('.yes-results').hide();
                UX.federatedLogin.toggleAttributes();
            });

            $(ms).on('keydown', function (...params) {
                // eslint-disable-next-line
                const [_, ms, e] = params;
                federatedLogin.isDenialsRedirect && federatedLogin.otherOptionsTabLogic(e, ms);
                $('.yes-results').hide();
                UX.federatedLogin.toggleAttributes();
            });

            $(ms).on('load', function (e, m, t) {
                if (t.length > 0 && $('.ms-res-ctn.dropdown-menu').length > 0) {
                    $('.yes-results').show();
                    UX.federatedLogin.toggleAttributes(true);
                    federatedLogin.showEnterToSelectLabel();
                } else {
                    $('.yes-results').hide();
                    UX.federatedLogin.toggleAttributes();
                }
            });

            $(ms).on('keyup', function () {
                if ($('.ms-sel-ctn input').val() === '') {
                    $('.yes-results').hide();
                    UX.federatedLogin.toggleAttributes();
                }
            });

            $(ms).on('selectionchange', function (e, m) {
                $('.ms-sel-item').remove();
                UX.federatedLogin.toggleAttributes();
                // $('.ms-res-ctn.dropdown-menu').hide();
                $('.yes-results').hide();
                $('.ms-helper').remove();
                if (e.currentTarget.getSelection().length > 0) {
                    UX.federatedLogin.onSelectionchange(e, m);
                }
            });

            $instSaveChoiceInput.change(() => {
                if ($instSaveChoiceInput.prop('checked') === true)
                    $.removeCookie('DO_NOT_SAVE_SELECTED_INST', {path: '/'});
                else $.cookie('DO_NOT_SAVE_SELECTED_INST', true, {path: '/'});
            });

            $('body').on('click', function () {
                if ($('.custom-modal').hasClass('in')) {
                    $('.custom-modal .modal__dialog .close').click();
                }
            });
            $('body').on('click', '#learnMorePopup .close', function () {
                UX.dropBlock.on.hide();
            });

            $('.learn-more-dropBlock a').on('keydown', function (e) {
                if (e.keyCode === 13) {
                    $(this).click();
                }
            });

            SeamlessAccessService.retrieveEntity().then(
                function (res) {
                    if (UX.federatedLogin.isCheckboxWasChecked()) {
                        $instSaveChoiceInput.prop('checked', true);
                    }
                },
                function (err) {
                    UX.federatedLogin.showLocalStoragePreventedMsg();
                }
            );

            $mobileBackContainer.prepend($backContainer.html());

            //Open Seamless Access Modal
            $('#openLearnMorePopup').on('click', function () {
                $('#learnMorePopup').modal({
                    backdrop: 'static',
                    keyboard: false,
                });
            });
        },
        showEnterToSelectLabel: function () {
            setTimeout(function () {
                var $inrList = $('.ms-res-ctn.dropdown-menu');
                var $EnterToSelectLabel = $('.yes-results');
                var pos = $inrList.position();

                //var width = $inrList.width();
                var height = $inrList.outerHeight();
                var labelPos = pos?.top + height + 10;

                var $parent = $inrList.parent();
                $parent.append($EnterToSelectLabel);

                $EnterToSelectLabel.css({
                    position: 'absolute',
                    top: labelPos + 'px',
                    left: pos?.left + 'px',
                });
            }, 500); // Wait for half a second until the dropdown menu take its full height.
        },

        toggleAttributes: function (add) {
            if (add) {
                $('.ms-sel-ctn').attr('aria-expanded', 'true');
                $('.ms-sel-ctn').attr('aria-controls', 'sso-dropdown');
                $('.ms-res-ctn.dropdown-menu').attr('id', 'sso-dropdown');
            } else {
                $('.ms-sel-ctn input').removeAttr('aria-activedescendant');
                $('.ms-sel-ctn').attr('aria-expanded', 'false');
            }
        },

        onSelectionchange: function (e, m) {
            var instName = e.currentTarget.getSelection()[0].name;
            var instUrl = e.currentTarget.getSelection()[0].institutionUrl;
            var instAuthID = e.currentTarget.getSelection()[0].entityId;

            var $selectedInst = $(".institution[url^='" + instUrl + "']");
            var instAuthType = $selectedInst.attr('auth-type');
            var dataJson;
            var dataObj;

            e.preventDefault();
            m.clear();

            if (instAuthID === '' || instAuthID === 'undefined') {
                window.location.href = instUrl;
            } else {
                dataObj = {
                    id: instAuthID,
                    name: instName,
                    url: instUrl,
                    authType: instAuthType,
                };

                dataJson = JSON.stringify(dataObj);

                $.cookie('SELECTED_INST_DATA', dataJson, {path: '/'}); // Session cookie valid across the entire site.

                federatedLogin.updateSeamlessAccess(instAuthID, instName, instUrl);
            }
        },

        openFederationPage: function (anchor) {
            var instEntryTemplate =
                '<div class="institution-entry"><a class="institution-link" href="#" onclick="UX.federatedLogin.updateSeamlessAccess(\'%s1\', \'%s2\', \'%s3\');">%s2</a></div>';
            var $instsContainer = $('.sso-start-widget .insts-container');
            var $selectedFederationLink = $(anchor);
            var $fedInstitutionsList = $selectedFederationLink.siblings('.fed-institutions');
            var $instsList = $fedInstitutionsList.find('.institution');
            var $fedName = $('.fed-name-container .fed-name');

            federatedLogin.showInstitutionsPage();

            $instsContainer.html('');

            if ($instsList.length === 0) {
                $instsContainer.append('<p>No Institutions in this federation.</p>');
                return;
            }

            $.each($instsList, function (i, obj) {
                var name = $(obj).html();
                var url = $(obj).attr('url');
                var instId = $(obj).attr('auth-id');

                var instEntry;
                var entityId;
                var redirectUri;

                if (instId === '' || instId === 'undefined') {
                    // This is a Ping Federate institution; so find the entity_id param from the url:
                    entityId = '';

                    redirectUri = UX.achsUtils.getParameterByName('redirectUri', url);
                    entityId = UX.achsUtils.getParameterByName('entityId', redirectUri);

                    instEntry = instEntryTemplate.replace('%s1', entityId);
                } else {
                    instEntry = instEntryTemplate.replace('%s1', instId);
                }

                instEntry = instEntry.replace('%s2', name.replace(/\'/g, "\\'")); // replaces the first name.
                instEntry = instEntry.replace('%s2', name); // replaces the second name.
                instEntry = instEntry.replace('%s3', url);

                $instsContainer.append(instEntry);
            });

            $fedName.html($selectedFederationLink.html());
            window.scrollTo(0, 0);
        },

        showInstitutionsPage: function () {
            var $instsPagePreferenceOptionsContainer = $('.insts-preference-options-container');
            var $fedsPage = $('.sso-start-widget .feds-page');
            var $instsPage = $('.sso-start-widget .insts-page');
            var $mobileBackContainer = $('.mobile-back-container');

            $('.preference-institution').appendTo($instsPagePreferenceOptionsContainer);
            $('.popupMessageDropZone').appendTo($instsPagePreferenceOptionsContainer);
            $('.local-storage-prevent').appendTo($instsPagePreferenceOptionsContainer);

            $fedsPage.addClass('hide');
            $instsPage.removeClass('hide');
            $('.custom-modal').addClass('center-modal');
            $('.custom-modal').closest('.learnMorePopup-container').addClass('full-page');

            $mobileBackContainer.removeClass('hide');
        },

        showFederationsPage: function () {
            var $fedsPagePreferenceOptionsContainer = $('.feds-preference-options-container');
            var $fedsPage = $('.sso-start-widget .feds-page');
            var $instsPage = $('.sso-start-widget .insts-page');
            var $mobileBackContainer = $('.mobile-back-container');

            $('.preference-institution').appendTo($fedsPagePreferenceOptionsContainer);
            $('.popupMessageDropZone').appendTo($fedsPagePreferenceOptionsContainer);
            $('.local-storage-prevent').appendTo($fedsPagePreferenceOptionsContainer);

            $fedsPage.removeClass('hide');

            $instsPage.addClass('hide');

            $mobileBackContainer.addClass('hide');
        },

        backToFedsList: function () {
            federatedLogin.showFederationsPage();
        },

        updateSeamlessAccess: function (instID, instName, instUrl) {
            var $instSaveChoiceInput = $('.preference-institution-input');
            var isChecked = $instSaveChoiceInput.prop('checked') === true;
            var entitydata;

            if (SeamlessAccessService && isChecked) {
                entitydata = {
                    entityID: instID,
                    title: instName,
                };

                SeamlessAccessService.updateEntity(entitydata).then(function (res) {
                    window.location.href = instUrl;
                });
            } else {
                window.location.href = instUrl;
            }
        },
        showLocalStoragePreventedMsg: function () {
            var $instSaveChoiceInput = $('.preference-institution-input');
            var $localStoragePrevent = $('.local-storage-prevent');

            $instSaveChoiceInput.prop('disabled', true);

            $localStoragePrevent.css('display', 'block');
        },
        hideLocalStoragePreventedMsg: function () {
            var $localStoragePrevent = $('.local-storage-prevent');
            $localStoragePrevent.css('display', 'none');
        },
        isCheckboxWasChecked: function () {
            return $.cookie('DO_NOT_SAVE_SELECTED_INST') !== 'true';
        },

        updateMaggicSuggestProperties: function () {
            federatedLogin.noMatchFoundMessage += ' Explore your other access options below.';
            federatedLogin.useTabKey = true;
        },

        setObserver: function () {
            const institutionsWrapper = document.querySelector('.ms-helper');
            const configs = {attributes: true, subtree: true};

            UX.achsUtils.mutationObserverSubscription(
                federatedLogin.mutationCallback.bind(this),
                institutionsWrapper,
                configs,
                false
            );
        },

        mutationCallback: function () {
            const helper = document.querySelector('.ms-helper');
            const alertMessage = document.querySelector('.ms-helper div');
            const noResults = helper?.style.display === '' && alertMessage;

            if (noResults === federatedLogin.currentNoResultsState) return;

            if (noResults) {
                federatedLogin.accessOptions.classList.add('shown');
                federatedLogin.setFederationWrapperMargin(false);
                federatedLogin.areOtherOptionsShown = true;
            } else {
                federatedLogin.accessOptions.classList.remove('shown');
                federatedLogin.setFederationWrapperMargin();
                federatedLogin.areOtherOptionsShown = false;
            }

            federatedLogin.currentNoResultsState = noResults;
        },

        otherOptionsTabLogic: function (e, ms) {
            if (e.which === 8 && !ms.getData().length) {
                federatedLogin.accessOptions.classList.remove('shown');
                federatedLogin.setFederationWrapperMargin();
                federatedLogin.areOtherOptionsShown = false;
            }

            if (e.which === 9 && !e.shiftKey && federatedLogin.areOtherOptionsShown) {
                $('.access-options :focusable:first').focus();
            }

            if (e.which === 9 && !e.shiftKey && !federatedLogin.areOtherOptionsShown) {
                ms.empty();
                ms.collapse();
                $('.federations :focusable:first').focus();
            }

            if (e.which === 9 && e.shiftKey && federatedLogin.areOtherOptionsShown) {
                $('.learn-more-dropBlock a').focus();
            }

            if (e.which === 9 && e.shiftKey && !federatedLogin.areOtherOptionsShown) {
                ms.empty();
                ms.collapse();
                $('.learn-more-dropBlock a').focus();
            }
        },

        constructSeamlessAccessParams: function () {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = {};

            for (const [key, value] of urlSearchParams.entries()) {
                params[key] = decodeURIComponent(value);
            }

            federatedLogin.isDenialsRedirect = params.isDenialsRedirect;
            return params;
        },

        constructSeamlessAccessLabels: function () {
            const {isLoggedIn, memberLabel, showAgreement, purchaseUrl, remainingAllowance} =
                federatedLogin.seamlessAccessParams;

            federatedLogin.hideCartDropzoneWhenEmpty();
            federatedLogin.handleChinaRegion(purchaseUrl);
            federatedLogin.handleDisableState(memberLabel, showAgreement);
            federatedLogin.pushStaticClasses(showAgreement, memberLabel, isLoggedIn);
            federatedLogin.showRemainingAllowances(remainingAllowance);
            federatedLogin.addOtherOptionsClasses();
        },

        hideCartDropzoneWhenEmpty: function () {
            const cartDropZone = federatedLogin.accessOptions.querySelector('.cartLinkDropZone');
            const cartDropZoneLink = cartDropZone.querySelector('a');

            if (cartDropZoneLink) return;
            cartDropZone?.classList.add('hidden');
        },

        handleChinaRegion: function (purchaseUrl) {
            if (purchaseUrl) return;
            federatedLogin.purchaseBlock.classList.add('hidden');
        },

        handleDisableState: function (memberLabel, showAgreement) {
            if (memberLabel === 'unavailable' || showAgreement) {
                const accessOptionsLogin = federatedLogin.accessOptions.querySelector('.access-options__login');

                federatedLogin.classes.push('disabled');
                accessOptionsLogin.setAttribute('aria-disabled', true);

                accessOptionsLogin.addEventListener('keydown', e => {
                    if (e.which !== 13) return;
                    e.preventDefault();
                });
            }
        },

        pushStaticClasses: function (showAgreement, memberLabel, isLoggedIn) {
            if (showAgreement) {
                federatedLogin.classes.push(showAgreement);
            }

            if (memberLabel) {
                federatedLogin.classes.push(memberLabel);
            }

            if (isLoggedIn) {
                federatedLogin.classes.push(isLoggedIn);
            }
        },

        showRemainingAllowances: function (remainingAllowance) {
            const showRemaingingElement = federatedLogin.accessOptions.querySelector('.remaining-memebr-benifits');

            if (!remainingAllowance) return;

            federatedLogin.classes.push('show-remaining');
            showRemaingingElement.textContent = ` ${remainingAllowance} `;
        },

        addOtherOptionsClasses: function () {
            federatedLogin.classes.forEach(className => {
                federatedLogin.accessOptions.classList.add(className);
            });
        },

        setFederationWrapperMargin: function (add = true) {
            if (!federatedLogin.isTablet) {
                federatedLogin.federations.style.marginTop = 0;
                return;
            }

            const heightWithMargin =
                federatedLogin.accessOptions.clientHeight + federatedLogin.institutionWrapperMargin;

            if (add) {
                federatedLogin.federations.style.marginTop = `${-heightWithMargin}px`;
            } else {
                federatedLogin.federations.style.marginTop = 0;
            }
        },

        handleOrientationChange: function () {
            federatedLogin.isTablet = window.matchMedia(`(max-width: ${UX.grid.screenSm - 1}px)`).matches;
            federatedLogin.setFederationWrapperMargin();
        },

        setFederationWrapperListener: function () {
            screen.orientation.addEventListener('change', federatedLogin.handleOrientationChange);
        },
    };

    UX.federatedLogin = federatedLogin;
})();
